export default __webpack_public_path__ + "static/media/clock.4b7cde7e.svg";